export default {
  en: {
    title: 'Goals',
    loading: 'Loading',
    loadError: 'Failed to load',
  },
  ru: {
    title: 'Цели',
    loading: 'Загружаю',
    loadError: 'Не удалось загрузить',
  },
  de: {
    title: 'Ziele',
    loading: 'Lädt',
    loadError: 'Laden fehlgeschlagen',
  },
  pt: {
    title: 'Objetivos',
    loading: 'Carregando',
    loadError: 'Falha ao carregar',
  },
  fr: {
    title: 'Objectifs',
    loading: 'Chargement',
    loadError: 'Échec du chargement',
  },
  es: {
    title: 'Objetivos',
    loading: 'Cargando',
    loadError: 'No se pudo cargar',
  },
};
